export const TERMINALS = {
  ROOT: 'app',
  Home: 'home',
  Settings: 'settings/profile',
  RoadMap: 'road-map',
  ComingSoon: 'coming-soon',
  ParentGroups: {
    Overview: 'overview',
    Risk: 'risk',
    Documents: 'documents',
  },
  StatusTracker: {
    ROOT: 'status-tracker',
    ComplianceOverview: 'compliance-overview',
    WrittenInfoSecurity: 'written-info',
    WrittenRiskAssessment: 'written-risk-assessment',
    SecurityAwareness: 'security-awareness',
    OverseeServiceProviders: 'oversee-service-providers',
    AccessControl: 'access-control',
    TechnicalRequirements: 'tech-requirements',
    SecurityTesting: 'security-testing',
    DevelopResponsePlan: 'develop-response',
    ExecReporting: 'exec-reporting',
  },
  SecurityDashboard: {
    ROOT: 'security-dashboard',
    ComplianceOverview: 'compliance-overview',
    WrittenInfoSecurity: 'written-info',
    WrittenRiskAssessment: 'written-risk-assessment',
    SecurityAwareness: 'security-awareness',
    OverseeServiceProviders: 'oversee-service-providers',
    AccessControl: 'access-control',
    TechnicalRequirements: 'tech-requirements',
    SecurityTesting: 'security-testing',
    DevelopResponsePlan: 'develop-response',
    ExecReporting: 'exec-reporting',
  },
  Dealerships: {
    ROOT: 'dealerships',
    General: 'general',
    Members: 'members',
    Settings: 'settings',
    Notifications: 'notification-settings',
    DealershipInformation: 'dealership-information',
    Automation: 'automation',
    Create: 'create',
  },
  Policies: {
    ROOT: 'policies',
    Create: {
      ROOT: 'new',
      SelectTemplate: 'select-template',
      DealerSelect: 'dealer-select',
      CompleteDocument: 'complete-document',
      CustomizeDocument: 'customize-document',
    },
    Edit: {
      ROOT: 'edit',
      EditDocument: 'edit-document',
      CustomizeDocument: 'customize-document',
    },
    Details: `:policyId`,
  },
  Uploads: {
    ROOT: 'uploads',
    Create: 'new',
  },
  ExecutiveReports: {
    ROOT: 'executive-reports',
    Create: 'new',
  },
  SecurityReports: {
    ROOT: 'security-reports',
  },
  RiskAssessments: {
    ROOT: 'risk-assessments',
    Create: 'new',
    Details: ':riskAssessmentId',
    Answers: 'answers',
  },
  RiskRegistry: {
    ROOT: 'risk-registry',
  },
  VendorAssessments: {
    ROOT: 'vendor-assessments',
    Create: 'new',
  },
  SecurityOps: {
    ROOT: 'security-dashboard',
    DeviceManagement: 'device-management',
    SecurityResponse: 'security-response',
    SecurityTraining: 'security-training',
    PhishingSimulation: 'phishing-simulation',
    SecurityTesting: 'security-testing',
  },
} as const;

export const ROUTES = {
  Root: `/${TERMINALS.ROOT}/*`,
  Settings: `/${TERMINALS.Settings}`,
  Roadmap: `/${TERMINALS.RoadMap}/`,
  ComingSoon: `/${TERMINALS.ComingSoon}/`,
  Overview: {
    Root: `/${TERMINALS.ParentGroups.Overview}/*`,
    Home: `/${TERMINALS.Home}/*`,
    Dealerships: {
      Root: `/${TERMINALS.Dealerships.ROOT}/*`,
      Create: `/${TERMINALS.Dealerships.Create}`,
      Dealership: {
        Root: `:dealershipId/*`,
        General: `${TERMINALS.Dealerships.General}`,
        Members: `${TERMINALS.Dealerships.Members}`,
        Settings: `${TERMINALS.Dealerships.Settings}`,
        Notifications: `${TERMINALS.Dealerships.Notifications}`,
        DealershipInformation: `${TERMINALS.Dealerships.DealershipInformation}`,
        Automation: `${TERMINALS.Dealerships.Automation}`,
      },
    },
    SecurityDashboard: {
      Root: `/${TERMINALS.SecurityDashboard.ROOT}/*`,
    },
    SecurityOps: {
      Root: `/${TERMINALS.SecurityOps.ROOT}/*`,
      DeviceManagement: `/${TERMINALS.SecurityOps.DeviceManagement}`,
      SecurityResponse: `/${TERMINALS.SecurityOps.SecurityResponse}`,
      SecurityTraining: `/${TERMINALS.SecurityOps.SecurityTraining}`,
      PhishingSimulation: `/${TERMINALS.SecurityOps.PhishingSimulation}`,
      SecurityTesting: `/${TERMINALS.SecurityOps.SecurityTesting}`,
    },
    StatusTracker: {
      Root: `/${TERMINALS.StatusTracker.ROOT}/*`,
      ComplianceOverview: `/${TERMINALS.StatusTracker.ComplianceOverview}`,
      WrittenInfoSecurity: `/${TERMINALS.StatusTracker.WrittenInfoSecurity}`,
      WrittenRiskAssessment: `/${TERMINALS.StatusTracker.WrittenRiskAssessment}`,
      SecurityAwareness: `/${TERMINALS.StatusTracker.SecurityAwareness}`,
      OverseeServiceProviders: `/${TERMINALS.StatusTracker.OverseeServiceProviders}`,
      AccessControl: `/${TERMINALS.StatusTracker.AccessControl}`,
      TechnicalRequirements: `/${TERMINALS.StatusTracker.TechnicalRequirements}`,
      SecurityTesting: `/${TERMINALS.StatusTracker.SecurityTesting}`,
      DevelopResponsePlan: `/${TERMINALS.StatusTracker.DevelopResponsePlan}`,
      ExecReporting: `/${TERMINALS.StatusTracker.ExecReporting}`,
    },
  },
  Risk: {
    Root: `/${TERMINALS.ParentGroups.Risk}/*`,
    RiskAssessments: {
      Root: `/${TERMINALS.RiskAssessments.ROOT}/*`,
      Create: `/${TERMINALS.RiskAssessments.Create}`,
      Details: `${TERMINALS.RiskAssessments.Details}/*`,
      Answers: `${TERMINALS.RiskAssessments.Details}/${TERMINALS.RiskAssessments.Answers}/*`,
    },
    RiskRegistry: {
      Root: `/${TERMINALS.RiskRegistry.ROOT}/*`,
    },
    VendorAssessments: {
      Root: `/${TERMINALS.VendorAssessments.ROOT}/*`,
      Create: `/${TERMINALS.VendorAssessments.Create}`,
      Details: `/:vendorAssessmentId/*`,
    },
  },
  Documents: {
    Root: `/${TERMINALS.ParentGroups.Documents}/*`,
    Policies: {
      Root: `/${TERMINALS.Policies.ROOT}/*`,
      Create: {
        New: `/${TERMINALS.Policies.Create.ROOT}/*`,
        Draft: `/${TERMINALS.Policies.Details}/${TERMINALS.Policies.Create.ROOT}/*`,
        SelectTemplate: `/${TERMINALS.Policies.Create.SelectTemplate}`,
        DealerSelect: `/${TERMINALS.Policies.Create.DealerSelect}`,
        CompleteDocument: `/${TERMINALS.Policies.Create.CompleteDocument}`,
        CustomizeDocument: `/${TERMINALS.Policies.Create.CustomizeDocument}`,
      },
      Policy: `/${TERMINALS.Policies.Details}/*`,
      Edit: {
        Root: `/${TERMINALS.Policies.Details}/${TERMINALS.Policies.Edit.ROOT}/*`,
        EditDocument: `/${TERMINALS.Policies.Edit.EditDocument}`,
        CustomizeDocument: `/${TERMINALS.Policies.Edit.CustomizeDocument}`,
      },
    },
    Uploads: {
      Root: `/${TERMINALS.Uploads.ROOT}/*`,
      Create: `/${TERMINALS.Uploads.Create}`,
      Details: `/:documentId/*`,
    },
    ExecutiveReports: {
      Root: `/${TERMINALS.ExecutiveReports.ROOT}/*`,
      Create: `/${TERMINALS.ExecutiveReports.Create}`,
      Details: `/:executiveReportId`,
    },
    SecurityReports: {
      Root: `/${TERMINALS.SecurityReports.ROOT}/*`,
    },
  },
} as const;

export const PATHS = {
  ROOT: `/${TERMINALS.ROOT}`,
  get Roadmap() {
    return `${this.ROOT}/${TERMINALS.RoadMap}` as const;
  },
  get ComingSoon() {
    return `${this.ROOT}/${TERMINALS.ComingSoon}` as const;
  },
  get Settings() {
    return `${this.ROOT}/${TERMINALS.Settings}` as const;
  },
  get Overview() {
    return {
      ROOT: `${this.ROOT}/${TERMINALS.ParentGroups.Overview}`,
      get Home() {
        return `${this.ROOT}/${TERMINALS.Home}` as const;
      },
      get Dealerships() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.Dealerships.ROOT}`,
          get Create() {
            return `${this.ROOT}/${TERMINALS.Dealerships.Create}` as const;
          },
          Dealership: {
            ROOT: (dealershipId: string | number) =>
              `${this.ROOT}/${TERMINALS.Dealerships.ROOT}/${dealershipId}` as const,
            General(dealershipId: string | number) {
              return `${this.ROOT(dealershipId)}/${TERMINALS.Dealerships.General}` as const;
            },
            Members(dealershipId: string | number) {
              return `${this.ROOT(dealershipId)}/${TERMINALS.Dealerships.Members}` as const;
            },
            Settings(dealershipId: string | number) {
              return `${this.ROOT(dealershipId)}/${TERMINALS.Dealerships.Settings}` as const;
            },
            Notifications(dealershipId: string | number) {
              return `${this.ROOT(dealershipId)}/${TERMINALS.Dealerships.Notifications}` as const;
            },
            DealershipInformation(dealershipId: string | number) {
              return `${this.ROOT(dealershipId)}/${TERMINALS.Dealerships.DealershipInformation}` as const;
            },
            Automation(dealershipId: string | number) {
              return `${this.ROOT(dealershipId)}/${TERMINALS.Dealerships.Automation}` as const;
            },
          } as const,
        } as const;
      },
      get SecurityOps() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.SecurityOps.ROOT}`,
          get DeviceManagement() {
            return `${this.ROOT}/${TERMINALS.SecurityOps.DeviceManagement}` as const;
          },
          get SecurityResponse() {
            return `${this.ROOT}/${TERMINALS.SecurityOps.SecurityResponse}` as const;
          },
          get SecurityTraining() {
            return `${this.ROOT}/${TERMINALS.SecurityOps.SecurityTraining}` as const;
          },
          get PhishingSimulation() {
            return `${this.ROOT}/${TERMINALS.SecurityOps.PhishingSimulation}` as const;
          },
          get SecurityTesting() {
            return `${this.ROOT}/${TERMINALS.SecurityOps.SecurityTesting}` as const;
          },
        } as const;
      },
      get SecurityDashboard() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.SecurityDashboard.ROOT}`,
        } as const;
      },
      get StatusTracker() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.StatusTracker.ROOT}`,
          get ComplianceOverview() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.ComplianceOverview}` as const;
          },
          get WrittenInfoSecurity() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.WrittenInfoSecurity}` as const;
          },
          get WrittenRiskAssessment() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.WrittenRiskAssessment}` as const;
          },
          get SecurityAwareness() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.SecurityAwareness}` as const;
          },
          get OverseeServiceProviders() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.OverseeServiceProviders}` as const;
          },
          get AccessControl() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.AccessControl}` as const;
          },
          get TechnicalRequirements() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.TechnicalRequirements}` as const;
          },
          get SecurityTesting() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.SecurityTesting}` as const;
          },
          get DevelopResponsePlan() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.DevelopResponsePlan}` as const;
          },
          get ExecReporting() {
            return `${this.ROOT}/${TERMINALS.StatusTracker.ExecReporting}` as const;
          },
        } as const;
      },
    } as const;
  },
  get Risk() {
    return {
      ROOT: `${this.ROOT}/${TERMINALS.ParentGroups.Risk}`,
      get RiskAssessments() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.RiskAssessments.ROOT}`,
          get Create() {
            return `${this.ROOT}/${TERMINALS.RiskAssessments.Create}` as const;
          },
          RiskAssessment(riskAssessmentId: string | number) {
            return `${this.ROOT}/${riskAssessmentId}` as const;
          },
          Answers(riskAssessmentId: string | number) {
            return `${this.RiskAssessment(riskAssessmentId)}/${TERMINALS.RiskAssessments.Answers}` as const;
          },
        } as const;
      },
      get RiskRegistry() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.RiskRegistry.ROOT}`,
        } as const;
      },
      get VendorAssessments() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.VendorAssessments.ROOT}`,
          get Create() {
            return `${this.ROOT}/${TERMINALS.VendorAssessments.Create}` as const;
          },
          VendorAssessment(vendorOrganizationId: string | number) {
            return `${this.ROOT}/${vendorOrganizationId}` as const;
          },
        } as const;
      },
    } as const;
  },
  get Documents() {
    return {
      ROOT: `${this.ROOT}/${TERMINALS.ParentGroups.Documents}`,
      get Policies() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.Policies.ROOT}`,
          get Create() {
            return {
              ROOT: (policyId?: string | number) =>
                policyId
                  ? (`${this.ROOT}/${policyId}/${TERMINALS.Policies.Create.ROOT}` as const)
                  : (`${this.ROOT}/${TERMINALS.Policies.Create.ROOT}` as const),
              get Steps() {
                return {
                  SelectTemplate: (policyId?: string | number) =>
                    `${this.ROOT(policyId)}/${TERMINALS.Policies.Create.SelectTemplate}` as const,
                  DealerSelect: (policyId?: string | number) =>
                    `${this.ROOT(policyId)}/${TERMINALS.Policies.Create.DealerSelect}` as const,
                  CompleteDocument: (policyId?: string | number) =>
                    `${this.ROOT(policyId)}/${TERMINALS.Policies.Create.CompleteDocument}` as const,
                  CustomizeDocument: (policyId?: string | number) =>
                    `${this.ROOT(policyId)}/${TERMINALS.Policies.Create.CustomizeDocument}` as const,
                };
              },
            };
          },
          Policy(policyId: string | number) {
            return `${this.ROOT}/${policyId}` as const;
          },
          get Edit() {
            return {
              ROOT: (policyId: string | number) => `${this.Policy(policyId)}/${TERMINALS.Policies.Edit.ROOT}` as const,
              EditDocument(policyId: string | number) {
                return `${this.ROOT(policyId)}/${TERMINALS.Policies.Edit.EditDocument}` as const;
              },
              CustomizeDocument(policyId: string | number) {
                return `${this.ROOT(policyId)}/${TERMINALS.Policies.Edit.CustomizeDocument}` as const;
              },
            };
          },
        } as const;
      },
      get Uploads() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.Uploads.ROOT}`,
          get Create() {
            return `${this.ROOT}/${TERMINALS.Uploads.Create}` as const;
          },
          Details(documentId: string | number) {
            return `${this.ROOT}/${documentId}` as const;
          },
        } as const;
      },
      get ExecutiveReports() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.ExecutiveReports.ROOT}`,
          get Create() {
            return `${this.ROOT}/${TERMINALS.ExecutiveReports.Create}` as const;
          },
          ExecutiveReport(executiveReportId: string | number) {
            return `${this.ROOT}/${executiveReportId}` as const;
          },
        } as const;
      },
      get SecurityReports() {
        return {
          ROOT: `${this.ROOT}/${TERMINALS.SecurityReports.ROOT}`,
        } as const;
      },
    } as const;
  },
} as const;

export const HOME_PATH = PATHS.Overview.Home;
export const POLICIES_HOME_PATH = PATHS.Documents.Policies.ROOT;
export const DOCUMENT_REPOSITORY_HOME_PATH = PATHS.Documents.Uploads.ROOT;
export const RISK_ASSESSMENTS_HOME_PATH = PATHS.Risk.RiskAssessments.ROOT;
export const RISK_REGISTRY_HOME_PATH = PATHS.Risk.RiskRegistry.ROOT;
export const VENDOR_ASSESSMENTS_HOME_PATH = PATHS.Risk.VendorAssessments.ROOT;
export const EXECUTIVE_REPORTS_HOME_PATH = PATHS.Documents.ExecutiveReports.ROOT;
export const SECURITY_REPORTS_HOME_PATH = PATHS.Documents.SecurityReports.ROOT;
